import { render, staticRenderFns } from "./CorrectAnswerForm.vue?vue&type=template&id=0043d2a6&scoped=true&"
import script from "./CorrectAnswerForm.vue?vue&type=script&lang=ts&"
export * from "./CorrectAnswerForm.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectAnswerForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CorrectAnswerForm.vue?vue&type=style&index=1&id=0043d2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0043d2a6",
  null
  
)

export default component.exports